import React, { useState } from "react";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";
import { DF_OT0058Context } from "./context";
import GridHeader from "./Grid/GridHeader";
import GridBody from "./Grid/GridBody";
import { fnGetValueByKey } from "../../../helpers/functions";
import withRouter from "../../../components/Common/withRouter";

const DF_OT0058 = (props) => {
  console.log("🤖 %cTransação [DF_OT0058]", "color:green");

  const { userProfile, isModalPage } = useSelector((state) => ({
    userProfile: state.login.profile,
    isModalPage: state.Layout.isModalPage,
  }));

  const { navigate, location, params } = props.router;

  const [isLoading, setisLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalNuevo, setIsOpenModalNuevo] = useState(false);
  const [paramsOnFilter, setParamsOnFilter] = useState([]);
  const [triggerOnFilter, setTriggerOnFilter] = useState(false);
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  return (
    <React.Fragment>
      <DF_OT0058Context.Provider
        value={{
          isLoading,
          userProfile,
          setisLoading,
          isOpenModal,
          setIsOpenModal,
          isOpenModalNuevo,
          setIsOpenModalNuevo,
          paramsOnFilter,
          setParamsOnFilter,
          fnGetValueByKey,
          triggerOnFilter,
          setTriggerOnFilter,
          inputGlobalSearchValue,
          setInputGlobalSearchValue,
          filteredData,
          setFilteredData,
          navigate,
          location,
          params,
        }}
      >
        <div
          className={`page-content df-ot0055-page-func ${isModalPage ? "p-0 overflow-hidden" : ""}`}
        >
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader />
            <GridBody />
          </Container>
        </div>
      </DF_OT0058Context.Provider>
    </React.Fragment>
  );
};

export default withRouter(DF_OT0058);
